import { TRANSLATED_ACTIONS } from '@/common/messages/actions';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const CreateDialog = defineMessages({
  title: {
    id: 'app.components.favourites.CreateDialog.title',
  },
  subtitle: {
    id: 'app.components.favourites.Dialog.subtitle',
  },
  save: TRANSLATED_ACTIONS.save,
  cancel: TRANSLATED_ACTIONS.cancel,
});

export const UpdateDialog = defineMessages({
  title: {
    id: 'app.components.favourites.UpdateDialog.title',
  },
  subtitle: {
    id: 'app.components.favourites.Dialog.subtitle',
  },
  save: TRANSLATED_ACTIONS.save,
  cancel: TRANSLATED_ACTIONS.cancel,
});

export const DeleteDialog = defineMessages({
  entityName: {
    id: 'app.components.favourites.DeleteDialog.entityName',
  },
});

export const MenuItem = defineMessages({
  rename: TRANSLATED_ACTIONS.rename,
  delete: {
    id: 'app.containers.favourites.deleteFavourite',
  },
});
